import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ImageRounded } from "../ImageRounded"
import { FixedSizeList, VariableSizeList as List } from "react-window"
import { useMediaQuery } from "react-responsive"
import { CheckBox, Input, TextArea } from "../Form"
import { IoQrCode, IoSettingsOutline } from "react-icons/io5"
import { ModalBody, ModalHeader, ModalPanel } from "../Modal"
import { Button } from "../Button"
import Accordion from "../Accordion"
import { InfoTooltip } from "../Tooltip"
import ModalHeaderBack from "../ModalHeaderBack"
import "./styles.scss"
import { QrCodeHistoryList } from "../QrCodeHistoryList"
import { QRCodeComponent } from "../QrCode"
import QRCodeConfigContainer from "../../container/QRCodeConfigContainer"
import { isMobile } from "react-device-detect"
import AddNumberConfigContainer from "../../container/AddNumberConfigContainer"

export const ListOrganizationsAndProjects = ({
  data,
  handleClick,
  handleSelect,
  defaultImage,
  hideScroll,
  className,
  projects = false,
  selectedCompany,
  selectedProject,
  currentScope,
  handleCloseQrModal,
  handleOpenQrModal,
  isQrCodeModalOpen,
  handleCloseAddModal,
  handleOpenAddModal,
  isAddNumberOpen,
  onChange,
}) => {
  const M = useMediaQuery({ query: "(max-height:768px)" })

  const Row = React.memo(({ index, style }) => {
    const row = data[index]

    return (
      <>
        {row && (
          <div style={isMobile ? { borderBottom: "1px solid #f2f2f2", width: "100%" } : style}>
            <li className={`list-org-project__item${className ? " " + className : ""}`}>
              {handleSelect && (
                <CheckBox
                  onChange={() => handleSelect(row?.value)}
                  checked={currentScope === row?.value}
                  disabled={!row.value}
                />
              )}
              <section className={`list-org-project__item${className ? " " + className : ""}`}>
                <div
                  className="list-org-project__item-icon"
                  onClick={() => handleClick && handleClick(row, !!projects)}>
                  <ImageRounded
                    icon={row.image || defaultImage}
                    className={
                      selectedCompany?.value === row?.value || selectedProject?.value === row?.value
                        ? "selected-company"
                        : ""
                    }
                  />
                </div>
                <div className="label__container">
                  <span onClick={() => handleClick && handleClick(row, !!projects)}>
                    {row?.name || row?.description}
                  </span>
                  {projects && (
                    <div>
                      <IoSettingsOutline
                        className="icon_content"
                        color="#0146ad"
                        style={{ marginRight: 10 }}
                        onClick={() => handleOpenAddModal(row)}
                      />
                      <IoQrCode
                        className="icon_content"
                        color="#0146ad"
                        onClick={() => handleOpenQrModal(row)}
                      />
                    </div>
                  )}
                </div>
                {row?.component && row?.component}
              </section>
            </li>
          </div>
        )}
      </>
    )
  })

  const labelEmpty = selectedCompany ? (
    <span>Não há empresas para esta organização</span>
  ) : (
    <span>Não há projetos para esta empresa</span>
  )

  return (
    <div className="list-org-project-container">
      {isMobile ? (
        <>
          <div className="list-org-project-pre-title">{projects ? "Projetos" : "Empresas"}</div>
          <div style={{ padding: "0px 16px 0px 16px" }}>
            <Input
              placeholder="Pesquisar pelo nome da empresa ou projeto"
              onChange={onChange}
              hasIcon={<i class="fi fi-rr-search"></i>}
              hasFocus={false}
            />
          </div>
        </>
      ) : (
        <div className="list-org-project-pre-title">{projects ? "Projeto(s)" : "Empresas(s)"}</div>
      )}
      <div className={`list-org-project${className ? " " + className : ""}`}>
        {data?.length > 0 ? (
          <FixedSizeList
            height={M ? 400 : 500}
            itemCount={data.length}
            itemSize={52}
            width={"100%"}
            itemData={data}
            innerElementType="ul"
            className={
              hideScroll ? "list-org-project-hide-scroll" : "list-org-project-scroll-style"
            }>
            {Row}
          </FixedSizeList>
        ) : (
          <div
            className="list-org-proj-empty"
            style={{
              height: M ? 400 : 500,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}>
            {labelEmpty}
          </div>
        )}
      </div>
      <QRCodeConfigContainer
        project={selectedProject}
        modalIsOpen={isQrCodeModalOpen}
        handleCloseModal={handleCloseQrModal}
      />
      <AddNumberConfigContainer
        project={selectedProject}
        modalIsOpen={isAddNumberOpen}
        handleCloseModal={handleCloseAddModal}
      />
    </div>
  )
}

export const AccordionQRList = ({ data, loading }) => {
  const AccordionHeader = ({ title, name }) => {
    return (
      <>
        <div className="add-form-accordion__header">
          <div className="accordion__header-title">
            <IoQrCode className="icon_content" color="#0146ad" size={24} />
            <span>QR Titulo</span>
          </div>
          <div className="accordion__header-actions">
            <InfoTooltip info="Excluir" trigger="hover">
              <button>
                <i className="fi fi-rr-trash"></i>
              </button>
            </InfoTooltip>

            <InfoTooltip info="Baixar">
              <button>
                <i className="fi fi-rr-download"></i>
              </button>
            </InfoTooltip>

            <InfoTooltip info="Copiar Link">
              <button>
                <i className="fi fi-rr-copy"></i>
              </button>
            </InfoTooltip>
          </div>
        </div>
      </>
    )
  }

  return (
    <div className="modal-container-qrcode__accordion">
      <Accordion header={<AccordionHeader />}>
        <div className="qrcode__accordion-content">
          <div className="qrcode__accordion-content__image-actions">
            <div className="actions-qrarea">sdfsdf</div>
            <div className="actions-buttons-area">
              <Button label="Baixar QRCode" />
              <Button label="Copiar link" variant="outline" />
            </div>
          </div>
          <div className="qrcode__accordion-content__details">
            <div className="details-messages">
              <span className="details-messages__label">Mensagens</span>
              <p className="details-messages__text">
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
              </p>
            </div>
            <div className="details-messages">
              <span className="details-messages__label">Mensagens</span>
              <p className="details-messages__text">
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore
                magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
                eiusmod tempor incididunt ut labore et dolore magna aliqua.{" "}
              </p>
            </div>
          </div>
        </div>
      </Accordion>
    </div>
  )
}
